import { ArticleQuery } from 'components/conversation/components/integrations/elevio/src/apis/graphQl/elevio/grappa/types/grappa.types';
import { elevioApi } from 'components/conversation/components/integrations/elevio/src/utils/apis/graphql/api';

import { ElevioBaseVariables } from '../types';
import { removeAnchorFromArticleId } from '../utils';

type Article = {
  articleData: ArticleQuery | undefined;
  error: any;
  isFetching: boolean;
};
type UseArticleParams = {
  id: string;
} & ElevioBaseVariables;
export function useArticle({
  id,
  ...langIdPageUrl
}: UseArticleParams): Article {
  const { data, error, isFetching } = elevioApi.grappa.useArticleQuery({
    ...langIdPageUrl,
    id: removeAnchorFromArticleId(id),
  });

  let articleData = data;
  /*
   * Required to reinstate any missing article id anchors that
   * might have been stripped out by removeArticleIdAnchorLink
   * and therefore not in the returned data payload.
   * eg: '12345' -> '12345#some-anchor'
   */
  if (articleData?.article) {
    // articleData is readonly so re-create object
    articleData = {
      ...articleData,
      article: {
        ...articleData.article,
        id,
      },
    };
  }

  return {
    error,
    isFetching,
    articleData,
  };
}
